// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ebec24c","239":"51b33805","455":"38e941f6"}[chunkId] + ".chunk.js";
};